module.exports = __webpack_public_path__ + "static/images/pass-card-bg03.59e7d34.png";